var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import GlideCarousel from './GlideCarousel';
import { themeGet, space, display, fontSize, border, borderRadius, } from 'styled-system';
import { themeWidth, themeMaxWidth, themeHeight, themeMaxHeight, } from '../theme/theme';
import VisuallyHidden from './VisuallyHidden';
import { LocaleConsumer } from '../providers/LocaleProvider';
import arrow from '../assets/icons/arrow-left.svg';
import arrowHoverState from '../assets/icons/arrow-left-hover-state.svg';
import { Link } from './Link';
var PrevNextButton = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  -webkit-appearance: none;\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  background-image: url(", ");\n  background-position: center;\n  background-size: ", ";\n  background-repeat: no-repeat;\n  background-color: white;\n  box-shadow: ", ";\n  opacity: 0.9;\n  cursor: pointer;\n\n  &:hover {\n    opacity: 1;\n  }\n\n  &:active,\n  &:focus {\n    outline: none;\n  }\n\n  &:active {\n    border: 1px solid ", ";\n    box-shadow: none;\n  }\n\n  &[disabled] {\n    opacity: 0.5;\n  }\n\n  &[disabled] {\n    display: none;\n  }\n"], ["\n  -webkit-appearance: none;\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  background-image: url(", ");\n  background-position: center;\n  background-size: ", ";\n  background-repeat: no-repeat;\n  background-color: white;\n  box-shadow: ",
    ";\n  opacity: 0.9;\n  cursor: pointer;\n\n  &:hover {\n    opacity: 1;\n  }\n\n  &:active,\n  &:focus {\n    outline: none;\n  }\n\n  &:active {\n    border: 1px solid ", ";\n    box-shadow: none;\n  }\n\n  &[disabled] {\n    opacity: 0.5;\n  }\n\n  &[disabled] {\n    display: none;\n  }\n"])), display, themeWidth, themeHeight, space, border, borderRadius, arrow, function (_a) {
    var arrowSize = _a.arrowSize;
    return arrowSize;
}, function (_a) {
    var controlShadow = _a.controlShadow, props = __rest(_a, ["controlShadow"]);
    return controlShadow || "0 0 0 1px " + themeGet('colors.gray.5')(props);
}, themeGet('colors.gray.10'));
PrevNextButton.defaultProps = {
    display: ['none', 'block'],
    themeWidth: 6,
    arrowSize: '22px',
    themeHeight: 6,
    p: 0,
    border: 'none',
    borderRadius: '100%',
};
var PrevButton = styled(PrevNextButton)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ",
    ";\n"])), function (_a) {
    var isVisualNavigation = _a.isVisualNavigation;
    return isVisualNavigation
        ? 'transform: translateY(-50%);'
        : 'left: 0; opacity: 0.45;';
});
var NextButton = styled(PrevNextButton)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ",
    ";\n"])), function (_a) {
    var isVisualNavigation = _a.isVisualNavigation;
    return isVisualNavigation
        ? 'transform: translateY(-50%) rotate(180deg);'
        : 'transform: rotate(180deg); right: 0; opacity: 0.45;';
});
var BottomCenterControlsGroup = styled.ul(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  list-style: none;\n  transform: translateY(100%) translateY(16px);\n"], ["\n  ", ";\n  ", ";\n  list-style: none;\n  transform: translateY(100%) translateY(16px);\n"])), display, space);
BottomCenterControlsGroup.defaultProps = {
    display: 'flex',
    m: 0,
    p: 0,
};
var ControlsItem = styled.li(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), space);
ControlsItem.defaultProps = {
    mx: 1,
};
var ControlsItemButton = styled.button(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  -webkit-appearance: none;\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  background-image: none;\n  background-color: ", ";\n\n  &[disabled] {\n    background-color: ", ";\n  }\n"], ["\n  -webkit-appearance: none;\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  background-image: none;\n  background-color: ", ";\n\n  &[disabled] {\n    background-color: ", ";\n  }\n"])), display, space, border, borderRadius, themeWidth, themeHeight, themeGet('colors.gray.5'), themeGet('colors.gray.10'));
ControlsItemButton.defaultProps = {
    display: 'block',
    themeWidth: 2,
    themeHeight: 2,
    m: 0,
    p: 0,
    border: 'none',
    borderRadius: '100%',
};
var SeeAllLink = styled(Link)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  text-decoration: none;\n\n  &::after {\n    content: '';\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    background-image: url(", ");\n    background-position: center;\n    background-size: 22px;\n    background-repeat: no-repeat;\n    transform: rotate(180deg);\n  }\n\n  &:hover {\n    &::after {\n      background-image: url(", ");\n    }\n  }\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  text-decoration: none;\n\n  &::after {\n    content: '';\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    background-image: url(", ");\n    background-position: center;\n    background-size: 22px;\n    background-repeat: no-repeat;\n    transform: rotate(180deg);\n  }\n\n  &:hover {\n    &::after {\n      background-image: url(", ");\n    }\n  }\n"])), display, space, fontSize, themeWidth, themeMaxWidth, themeHeight, themeMaxHeight, arrow, arrowHoverState);
SeeAllLink.defaultProps = __assign({}, Link.defaultProps, { display: 'inline-flex', themeWidth: 4, themeMaxWidth: 4, themeHeight: 4, themeMaxHeight: 4, pb: [4, '28px', '42px'] });
var ArrowRight = styled.img(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  transform: rotate(180deg);\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  transform: rotate(180deg);\n"])), themeWidth, themeMaxWidth, themeHeight, themeMaxHeight);
ArrowRight.defaultProps = {
    src: arrow,
    role: 'presentation',
    themeWidth: 4,
    themeMaxWidth: 4,
    themeHeight: 4,
    themeMaxHeight: 4,
};
export var BottomCenterControls = function (_a) {
    var goToSlide = _a.goToSlide, slideCount = _a.slideCount, currentSlide = _a.currentSlide;
    return (React.createElement(BottomCenterControlsGroup, null, Array.from({ length: slideCount }, function (_, index) { return (React.createElement(ControlsItem, { key: index },
        React.createElement(ControlsItemButton, { onClick: function () { return goToSlide(index); }, disabled: currentSlide === index, "data-testid": "carousel-control-goto-" + index },
            React.createElement(LocaleConsumer, null, function (l10n) { return (React.createElement(VisuallyHidden, null, l10n.replace.t('h24_go_to_item', { number: index + 1 }))); })))); })));
};
BottomCenterControls.propTypes = {
    goToSlide: PropTypes.func.isRequired,
    slideCount: PropTypes.number.isRequired,
    currentSlide: PropTypes.number.isRequired,
};
export var CenterLeftControls = function (_a) {
    var previousSlide = _a.previousSlide, currentSlide = _a.currentSlide, slideCount = _a.slideCount, isVisualNavigation = _a.isVisualNavigation, size = _a.size, props = __rest(_a, ["previousSlide", "currentSlide", "slideCount", "isVisualNavigation", "size"]);
    return (React.createElement(PrevButton, __assign({ themeHeight: size, themeWidth: size, disabled: slideCount === 1 || (isVisualNavigation && currentSlide === 0), onClick: previousSlide, isVisualNavigation: isVisualNavigation, "data-testid": "carousel-control-previous", mb: isVisualNavigation ? [null, '-18px', '-2px'] : ['32px', 0] }, props),
        React.createElement(LocaleConsumer, null, function (l10n) { return (React.createElement(VisuallyHidden, null, l10n.t('h24_carousel_prev_item'))); })));
};
CenterLeftControls.propTypes = {
    size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    arrowSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    controlShadow: PropTypes.string,
    previousSlide: PropTypes.func.isRequired,
    slideCount: PropTypes.number.isRequired,
    currentSlide: PropTypes.number.isRequired,
    isVisualNavigation: PropTypes.bool,
};
CenterLeftControls.defaultProps = {
    isVisualNavigation: false,
};
export var CenterRightControls = function (_a) {
    var canScrollToTheLastSlide = _a.canScrollToTheLastSlide, nextSlide = _a.nextSlide, slideCount = _a.slideCount, currentSlide = _a.currentSlide, isVisualNavigation = _a.isVisualNavigation, slidesToShow = _a.slidesToShow, seeAllLink = _a.seeAllLink, size = _a.size, props = __rest(_a, ["canScrollToTheLastSlide", "nextSlide", "slideCount", "currentSlide", "isVisualNavigation", "slidesToShow", "seeAllLink", "size"]);
    var isAtCarouselEnd = canScrollToTheLastSlide
        ? currentSlide + 1 === slideCount
        : currentSlide >= slideCount - slidesToShow;
    if (isVisualNavigation && seeAllLink && isAtCarouselEnd) {
        return (React.createElement(SeeAllLink, { "data-testid": "see-all-link", fontSize: 4, lineHeight: 3, textDecoration: "underline", href: seeAllLink.href }, seeAllLink.label));
    }
    return (React.createElement(NextButton, __assign({ themeHeight: size, themeWidth: size, disabled: slideCount === 1 || (isVisualNavigation && isAtCarouselEnd), onClick: nextSlide, isVisualNavigation: isVisualNavigation, "data-testid": "carousel-control-next", mb: isVisualNavigation ? [null, '-18px', '-2px'] : ['32px', 0] }, props),
        React.createElement(LocaleConsumer, null, function (l10n) { return (React.createElement(VisuallyHidden, null, l10n.t('h24_carousel_next_item'))); })));
};
CenterRightControls.propTypes = {
    size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    arrowSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    controlShadow: PropTypes.string,
    nextSlide: PropTypes.func.isRequired,
    slideCount: PropTypes.number.isRequired,
    currentSlide: PropTypes.number.isRequired,
    isVisualNavigation: PropTypes.bool,
    slidesToShow: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
    seeAllLink: PropTypes.shape({
        label: PropTypes.string,
        href: PropTypes.string,
    }),
};
CenterRightControls.defaultProps = {
    isVisualNavigation: false,
    slidesToShow: 1,
    seeAllLink: null,
};
export var Carousel = GlideCarousel;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
